<template>
  <div class="main">
    <!-- <select name="DDLX" id="DDLX" class="dropdown">
      			<option selected="selected" value="车身长度">车身长度</option>
      			<option value="车身宽度">车身宽度</option>
      			<option value="车身高度">车身高度</option>
      			<option value="轴距">轴距</option>
      			<option value="最大功率">最大功率</option>
      			<option value="最大扭矩">最大扭矩</option>
      			<option value="最高车速">最高车速</option>
      			<option value="60km/h等速油耗">60km/h等速油耗</option>
      			<option value="90km/h等速油耗">90km/h等速油耗</option>
      			<option value="120km/h等速油耗">120km/h等速油耗</option>
      			<option value="综合工况油耗">综合工况油耗</option>
      			<option value="MSRP">MSRP</option>
      </select>-->
    <div class="breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>三维分析</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    
    <EquipSearch :moduleName="currentModuleName" v-if="!viewResult">
      <el-button @click="showDimension" type="primary">三维分析</el-button>
    </EquipSearch>
    <div v-if="viewResult" v-loading="showLoadding">
      <div style="margin-top:20px;">
        <xy-toolbox-menu>
          <xy-toolbox-menu-item custom style="width:835px;">
            <div class="custom-content">
              <el-select v-model="axisX" placeholder="X轴">
                <el-option v-for="item in selectVals" :key="item" :label="item" :value="item"></el-option>
              </el-select>
              <el-select v-model="axisY" placeholder="Y轴" style="margin-left:10px;">
                <el-option v-for="item in selectVals" :key="item" :label="item" :value="item"></el-option>
              </el-select>
              <el-date-picker style="margin-left:10px;" v-model="salesdate" type="monthrange" align="right" unlink-panels range-separator="至" start-placeholder="开始月份" end-placeholder="结束月份" :picker-options="pickerOptions"></el-date-picker>
              <el-button style="margin-left:10px;" @click="queryData">查询</el-button>
            </div>
          </xy-toolbox-menu-item>
          <xy-toolbox-menu-item divided />
          <xy-toolbox-menu-item icon="back" @click="chooseCars">重选车款</xy-toolbox-menu-item>
          <xy-toolbox-menu-item icon="excel" @click="exportExcel">导出</xy-toolbox-menu-item>
        </xy-toolbox-menu>
      </div>
      <el-collapse v-model="activeNames">
        <el-collapse-item title="数据" name="act1">
          <div style="margin:auto;overflow: auto;" v-show="dimensionList.length>0">
            <el-table border fit :data="dimensionList" stripe tooltip-effect="dark" height="700" style="width:99.9%;white-space:nowrap;">
              <el-table-column label="车款" prop="车款" key="lineName" width="400"></el-table-column>
              <el-table-column :label="item" :prop="item" v-for="(item, index) in columns" :key="index"></el-table-column>
            </el-table>
          </div>
        </el-collapse-item>
        <el-collapse-item title="图表" name="act2">
          <div id="chart"></div>
        </el-collapse-item>
      </el-collapse>
    </div>
  </div>
</template>

<style scoped>
  #chart {
    width: 100%;
    height: 400px;
    margin: 0 auto;
  }
</style>

<script>
  import EquipSearch from "@/components/common/NewSearchBar.vue";
  import {
    mapState,
    mapGetters,
    mapActions,
    mapMutations
  } from "vuex";
  export default {
    name: "dimension",
    components: {
      EquipSearch
    },
    data() {
      return {
        showLoadding: false,
        viewResult: false,
        chartInit:false,
        chart:null,
        activeNames: ["act1", "act2"],
        selectVals: [
          "车长",
          "车宽",
          "车高",
          "轴距",
          "最大功率",
          "最大扭矩",
          "最高车速",
          "60km/h等速油耗",
          "90km/h等速油耗",
          "120km/h等速油耗",
          "综合工况油耗",
          "MSRP"
        ],
        salesdate: [],
        axisX: "",
        axisY: "",
        columns: [],
        currentModuleName: "dimensionAnalysis",
        pickerOptions: {
          shortcuts: [{
              text: "本月",
              onClick(picker) {
                picker.$emit("pick", [new Date(), new Date()]);
              }
            },
            {
              text: "最近一个月",
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setMonth(start.getMonth() - 1);
                picker.$emit("pick", [start, end]);
              }
            },
            {
              text: "最近二个月",
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setMonth(start.getMonth() - 2);
                picker.$emit("pick", [start, end]);
              }
            },
            {
              text: "最近三个月",
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setMonth(start.getMonth() - 3);
                picker.$emit("pick", [start, end]);
              }
            },
            {
              text: "今年至今",
              onClick(picker) {
                const end = new Date();
                const start = new Date(new Date().getFullYear(), 0);
                picker.$emit("pick", [start, end]);
              }
            }
          ]
        }
      };
    },
    methods: {
      ...mapState({
        isLoading: state => state.loadingCount > 0
      }),
      ...mapMutations("depthanalysis", ["clearDimensionList"]),
      ...mapActions("depthanalysis", ["queryDimensionList"]),
      chooseCars() {
        this.viewResult = false;
      },
      queryData() {
        if (this.axisX == "" || this.axisY == "" || this.salesdate.length == 0) {
          this.$message({
            message: "请选择X、Y轴、和日期",
            duration: 2000
          });
          return ;
        }
        this.showLoadding = true;
        let ids = this.selectionResult.map(item => {
          return parseInt(item.id);
        });
        this.queryDimensionList({
          params: {
            ids: ids,
            salesdate: this.salesdate,
            axisX: this.axisX,
            axisY: this.axisY
          },
          handle: this.bindData
        });
      },
      showDimension() {
        this.viewResult = true;
        this.clearDimensionList();
      },
      bindData() {
        this.showLoadding = false;
        this.showChart();
      },
      showChart() {
        if(!this.chartInit)
        {
          this.chartInit  = true;
          this.initChart();
        
        }
     
       var legend = {right:10, data:[]};
          var data = [];
          for(var item of this.dimensionList)
          {
             // legend.data.push[item['车款']];
             data.push([item[this.axisX],item[this.axisY],item['销量'],item['车款'] ]);
          }
         this.chart.setOption({
           legend:legend,
           series:[ {
             name:'a',
        data: data,
        type: 'scatter',
        symbolSize: function (data) {
            return  1+Math.sqrt(data[2]/100) ;
        },
        emphasis: {
            label: {
                show: true,
                formatter: function (param) {
                    return   param.data[3];
                },
                position: 'top'
            }
        },
        itemStyle: {
            shadowBlur: 10,
            shadowColor: 'rgba(25, 100, 150, 0.5)',
            shadowOffsetY: 5,
            color: new echarts.graphic.RadialGradient(0.4, 0.3, 1, [{
                offset: 0,
                color: 'rgb(129, 227, 238)'
            }, {
                offset: 1,
                color: 'rgb(25, 183, 207)'
            }])
        }
    }]
         });
      },
      exportExcel() {
        JSONToExcel(this.dimensionList, "三维分析", "三维分析");
      },
      initChart() {
        let this_ = this;
        var myChart = echarts.init(document.getElementById("chart"));
         this.chart = myChart;
        var option = {
          title: {
            text: " "
          },
          legend: {
            right: 10,
            data: []
          },
          xAxis: {
            splitLine: {
              lineStyle: {
                type: "dashed"
              }
            }
          },
          yAxis: {
            splitLine: {
              lineStyle: {
                type: "dashed"
              }
            },
            scale: true
          },
          series: [ ]
        };
        myChart.setOption(option);
        //建议加上以下这一行代码，不加的效果图如下（当浏览器窗口缩小的时候）。超过了div的界限（红色边框）
        window.addEventListener("resize", function() {
          myChart.resize();
        });
      }
    },
    computed: {
      ...mapGetters("commonsearch", [
        "searchCategories",
        "hasSelectionResult",
        "hasSearchResult",
        "showSelectionSubmodel",
        "selectionResult",
        "searchResult"
      ]),
      ...mapGetters("depthanalysis", ["dimensionList"])
    },
    mounted() {
     // this.initChart();
    },
    watch: {
      dimensionList(newValue) {
        //   alert(JSON.stringify(this.newValue));
        this.columns.length = 0;
        for (var x in newValue[0]) {
          if (x != "id" && x != "车款") {
            this.columns.push(x);
          }
        }
      }
    }
  };
</script>

 